import countryLinks from '../data/countryLinks.json';
import guideLinks from '../data/guideLinks.json';
import { withSlash } from './urls';

/**
 * Hydrated-DOM twin of crawlerShell seoHref (docs/SEO_SLASH_LINKS_1028.md).
 *
 * Netlify serves every prerendered route at `/route/` and 301s `/route` there,
 * so a React <Link to="/about"> sends Googlebot through a redirect. publicHref
 * returns the slash form for prerendered public routes only (scripts/seo-meta.mjs
 * collectSeoRoutes, unit-tested) and leaves everything else as is: `/`, external
 * or hash-only hrefs, files, and app routes (/quiz/…, /login, /dashboard, /api…).
 * Kept light (two small JSON lists, no blog/menu data) because Navbar ships it.
 */
const STATIC_PATHS = new Set([
  '/cfa-mock-exams', '/pricing', '/blog', '/study-plan', '/glossary', '/level/2', '/level/3',
  '/careers', '/terms', '/referral-terms', '/privacy', '/about', '/contact', '/study-guide',
  // Prerendered, allowed by robots.txt and listed in the sitemap as /quiz/session/ (the shared Mocks nav link).
  '/quiz/session',
  ...countryLinks.map((page) => page.path),
  ...guideLinks.map((page) => page.path),
]);

/** /blog/<slug> posts and /study-guide/<topic>/… lessons are all prerendered. */
const PREFIX_RE = /^\/(blog\/[a-z0-9-]+|study-guide\/[a-z0-9/-]+)$/;

export function isPublicRoutePath(path) {
  const clean = String(path || '').replace(/\/+$/, '');
  return STATIC_PATHS.has(clean) || PREFIX_RE.test(clean);
}

/** '/about' → '/about/', '/blog/x#faq' → '/blog/x/#faq'; anything else unchanged. */
export function publicHref(href) {
  if (typeof href !== 'string' || !href.startsWith('/') || href.startsWith('//')) return href;
  const path = href.split(/[?#]/)[0];
  return isPublicRoutePath(path) ? withSlash(href) : href;
}
